import { useCallback, useEffect, useState } from "react";
import { getExportSong } from "@/lib/exportAudioApi";

const POLL_MS = 4000;

/** One song's export choices (mixes, finished parts) — keeps checking while its parts are being split. */
export default function useExportSong(songId) {
  const [detail, setDetail] = useState(null);
  const [error, setError] = useState(null);
  const refresh = useCallback(async () => {
    try { setDetail(await getExportSong(songId)); setError(null); } catch (e) { setError(e); }
  }, [songId]);
  useEffect(() => { refresh(); }, [refresh]);
  const splitting = detail?.split?.status === "running";
  useEffect(() => {
    if (!splitting) return undefined;
    const t = setInterval(refresh, POLL_MS);
    return () => clearInterval(t);
  }, [splitting, refresh]);
  return { detail, error, refresh, splitting };
}
